var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.5C6.125 19.5 3.5 18 2.0625 15.5C0.625 13.0312 0.625 10 2.0625 7.5C3.5 5.03125 6.125 3.5 9 3.5C11.8438 3.5 14.4688 5.03125 15.9062 7.5C17.3438 10 17.3438 13.0312 15.9062 15.5C14.4688 18 11.8438 19.5 9 19.5ZM6.46875 8.96875C6.15625 9.28125 6.15625 9.75 6.46875 10.0312L7.9375 11.5L6.46875 12.9688C6.15625 13.2812 6.15625 13.75 6.46875 14.0312C6.75 14.3438 7.21875 14.3438 7.5 14.0312L8.96875 12.5625L10.4375 14.0312C10.75 14.3438 11.2188 14.3438 11.5 14.0312C11.8125 13.75 11.8125 13.2812 11.5 12.9688L10.0312 11.5L11.5 10.0312C11.8125 9.75 11.8125 9.28125 11.5 8.96875C11.2188 8.6875 10.75 8.6875 10.4375 8.96875L8.96875 10.4375L7.5 8.96875C7.21875 8.6875 6.75 8.6875 6.46875 8.96875Z",
    fill: "#D91734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/Close_X.317d2664e04db9fe274d6b78b8ceea3e.svg";
export { ForwardRef as ReactComponent };